import { Button } from '@chakra-ui/react';
import { ArrowRight } from 'lucide-react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface Props {
	to: string;
	children: React.ReactNode;
}

/**
 * Gold call-to-action button that links to another page
 */
export default function CtaButton({ to, children }: Props) {
	return (
		<Button
			as={RouterLink}
			to={to}
			size={"lg"}
			textColor={"white.100"}
			backgroundColor={"yellow.100"}
			borderRadius={"full"}
			fontFamily={"Montserrat"}
			rightIcon={<ArrowRight size={20} />}
			transition={"transform 0.2s ease"}
			_hover={{ transform: "scale(1.05)", backgroundColor: "yellow.100" }}
			_active={{ transform: "scale(0.95)", backgroundColor: "yellow.100" }}
		>
			{children}
		</Button>
	);
}
